(() => {
  if (customElements.get('ff-launch')) return;

  class FlightFuelLaunch extends HTMLElement {
    connectedCallback() {
      this.offer = this.querySelector('[data-ff-launch-offer]');
      this.generalUpdates = this.querySelector('[data-ff-launch-general]');
      this.clock = this.querySelector('[data-ff-launch-clock]');
      this.deadlineDisplay = this.querySelector('[data-ff-launch-deadline]');
      this.tags = this.querySelector('[data-ff-launch-tags]');
      this.buttonCopy = this.querySelector('[data-ff-launch-button-copy]');
      this.successCopy = this.querySelector('[data-ff-launch-success-copy]');
      this.descriptionCopy = this.querySelector('[data-ff-launch-description]');
      this.announcement = this.querySelector('[data-ff-launch-expiry-announcement]');
      this.units = {
        days: this.querySelector('[data-ff-launch-days]'),
        hours: this.querySelector('[data-ff-launch-hours]'),
        minutes: this.querySelector('[data-ff-launch-minutes]'),
        seconds: this.querySelector('[data-ff-launch-seconds]'),
      };
      const deadline = this.dataset.offerDeadline || '';
      const hasTimezone = /(?:Z|[+-]\d{2}:\d{2})$/.test(deadline);
      this.offerDeadline = hasTimezone ? Date.parse(deadline) : NaN;
      this.offerEnabled = this.dataset.offerEnabled === 'true';
      this.summaryTemplate = this.clock?.dataset.summaryTemplate || '';
      this.onSubmit = () => this.refreshOffer();
      this.form = this.querySelector('form');
      this.form?.addEventListener('submit', this.onSubmit);

      if (this.deadlineDisplay && Number.isFinite(this.offerDeadline)) {
        try {
          this.deadlineDisplay.textContent = new Intl.DateTimeFormat('en-IE', {
            timeZone: 'Europe/Dublin', year: 'numeric', month: 'long', day: 'numeric',
            hour: '2-digit', minute: '2-digit', hourCycle: 'h23', timeZoneName: 'short',
          }).format(new Date(this.offerDeadline));
        } catch (_) {}
      }
      this.refreshOffer();
      if (this.offerActive) {
        this.offerTimer = window.setInterval(() => this.refreshOffer(), 1000);
      }

      this.response = this.querySelector('[data-ff-launch-response]');
      if (!this.response) return;
      this.focusFrame = window.requestAnimationFrame(() => {
        if (!this.isConnected) return;
        this.response.focus({ preventScroll: true });
        const bounds = this.response.getBoundingClientRect();
        if (bounds.top < 0 || bounds.bottom > window.innerHeight) {
          this.response.scrollIntoView({ block: 'center', behavior: 'auto' });
        }
      });
    }

    refreshOffer() {
      const wasActive = this.offerActive;
      const remaining = Number.isFinite(this.offerDeadline)
        ? Math.max(0, Math.ceil((this.offerDeadline - Date.now()) / 1000)) : 0;
      this.offerActive = this.offerEnabled && remaining > 0;
      if (this.offer) this.offer.hidden = !this.offerActive;
      if (this.generalUpdates) this.generalUpdates.hidden = this.offerActive;
      if (this.tags) {
        this.tags.value = this.offerActive ? this.tags.dataset.activeTags : this.tags.dataset.expiredTags;
      }
      for (const node of [this.buttonCopy, this.successCopy, this.descriptionCopy]) {
        if (node) node.textContent = this.offerActive ? node.dataset.activeCopy : node.dataset.expiredCopy;
      }
      if (this.offerActive && this.clock) {
        const values = {
          days: Math.floor(remaining / 86400),
          hours: Math.floor((remaining % 86400) / 3600),
          minutes: Math.floor((remaining % 3600) / 60),
          seconds: remaining % 60,
        };
        let summary = this.summaryTemplate;
        for (const [unit, value] of Object.entries(values)) {
          if (this.units[unit]) this.units[unit].textContent = String(value).padStart(2, '0');
          summary = summary.replace(`[${unit}]`, String(value));
        }
        this.clock.setAttribute('aria-label', summary);
      } else if (!this.offerActive) {
        window.clearInterval(this.offerTimer);
        if (wasActive && this.announcement) {
          this.announcement.textContent = this.announcement.dataset.expiryMessage;
        }
      }
    }

    disconnectedCallback() {
      window.clearInterval(this.offerTimer);
      window.cancelAnimationFrame(this.focusFrame);
      this.form?.removeEventListener('submit', this.onSubmit);
    }
  }

  customElements.define('ff-launch', FlightFuelLaunch);
})();
